/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Ship } from './Ship';
import {
    ShipFromJSON,
    ShipFromJSONTyped,
    ShipToJSON,
} from './Ship';

/**
 * begin: Start time for the track [UTC] default yesterday midnight, end: End time for the track [UTC] default last midnight. 
 * @export
 * @interface ShipHistoricalPost
 */
export interface ShipHistoricalPost {
    /**
     * 
     * @type {Ship}
     * @memberof ShipHistoricalPost
     */
    ship?: Ship;
    /**
     * Start timestamp for the track. Always UTC
     * @type {string}
     * @memberof ShipHistoricalPost
     */
    begin?: string;
    /**
     * End timestamp for the track. Always UTC
     * @type {string}
     * @memberof ShipHistoricalPost
     */
    end?: string;
    /**
     * Resolution of the track. Time between samples as hh:mm:ss
     * @type {string}
     * @memberof ShipHistoricalPost
     */
    resolution?: string;
}

/**
 * Check if a given object implements the ShipHistoricalPost interface.
 */
export function instanceOfShipHistoricalPost(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ShipHistoricalPostFromJSON(json: any): ShipHistoricalPost {
    return ShipHistoricalPostFromJSONTyped(json, false);
}

export function ShipHistoricalPostFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShipHistoricalPost {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ship': !exists(json, 'ship') ? undefined : ShipFromJSON(json['ship']),
        'begin': !exists(json, 'begin') ? undefined : json['begin'],
        'end': !exists(json, 'end') ? undefined : json['end'],
        'resolution': !exists(json, 'resolution') ? undefined : json['resolution'],
    };
}

export function ShipHistoricalPostToJSON(value?: ShipHistoricalPost | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ship': ShipToJSON(value.ship),
        'begin': value.begin,
        'end': value.end,
        'resolution': value.resolution,
    };
}

